import * as React from 'react';
import { debugMigrationForward } from './common';

export function debugProspectMigrationForward(benchmark, value, weighted) {
  return debugMigrationForward(benchmark, value, weighted);
}
